import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * CompsApiList 通用API接口列表面板组件
 * 用于显示接口列表，支持分类分组和选择
 * 支持一级分类（可折叠）和二级分类
 */
import React, { useState } from "react";
import { List, Typography, Tag, Space, Card, Collapse } from "antd";
import { COMPONENT_SPLIT_BORDER_BOTTOM } from "../theme/componentBorders";
import { DownOutlined } from "@ant-design/icons";
const { Text } = Typography;
const { Panel } = Collapse;
// 方法颜色映射
const METHOD_COLORS = {
    GET: "blue",
    POST: "green",
    PUT: "orange",
    DELETE: "red",
    PATCH: "purple",
};
const CompsApiList = ({ title = "接口列表", groups, categoryGroups, selectedId, onSelect, width = "400px", height = "100%", }) => {
    // 展开的一级分类key（用于控制折叠状态）
    const [expandedKeys, setExpandedKeys] = useState(() => {
        // 默认展开所有一级分类
        if (categoryGroups) {
            return categoryGroups.map((_, index) => `category-${index}`);
        }
        return [];
    });
    // 渲染接口列表项
    const renderApiListItem = (api) => (_jsx(List.Item, { onClick: () => onSelect(api.id), style: {
            cursor: "pointer",
            backgroundColor: selectedId === api.id ? "#e6f7ff" : "transparent",
            borderLeft: selectedId === api.id ? "3px solid #1890ff" : "3px solid transparent",
            padding: "12px 16px",
            transition: "all 0.3s",
        }, onMouseEnter: (e) => {
            if (selectedId !== api.id) {
                e.currentTarget.style.backgroundColor = "#f5f5f5";
            }
        }, onMouseLeave: (e) => {
            if (selectedId !== api.id) {
                e.currentTarget.style.backgroundColor = "transparent";
            }
        }, children: _jsxs(Space, { direction: "vertical", size: 4, style: { width: "100%" }, children: [_jsxs(Space, { children: [_jsx(Tag, { color: METHOD_COLORS[api.method], children: api.method }), _jsx(Text, { strong: true, style: { fontSize: "14px" }, children: api.name })] }), _jsx(Text, { type: "secondary", style: { fontSize: "12px" }, children: api.path })] }) }));
    // 渲染二级分类组（原来的方式）
    const renderGroup = ({ category, apis }, key) => (_jsxs("div", { children: [_jsx("div", { style: {
                    padding: "8px 16px",
                    backgroundColor: "#fafafa",
                    borderBottom: COMPONENT_SPLIT_BORDER_BOTTOM,
                    fontWeight: 600,
                    fontSize: "14px",
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                }, children: category }), _jsx(List, { size: "small", dataSource: apis, renderItem: renderApiListItem, split: false })] }, key));
    // 渲染一级分类（可折叠）
    const renderCategoryGroup = (categoryGroup, index) => {
        const panelKey = `category-${index}`;
        return (_jsx(Panel, { header: _jsx("span", { style: { fontWeight: 600, fontSize: "15px" }, children: categoryGroup.category }), children: categoryGroup.groups.map((group, groupIndex) => renderGroup(group, `${panelKey}-${groupIndex}`)) }, panelKey));
    };
    // 判断使用哪种显示方式
    const useCategoryGroups = categoryGroups && categoryGroups.length > 0;
    const useGroups = groups && groups.length > 0;
    return (_jsx(Card, { title: title, style: {
            width,
            height,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
        }, bodyStyle: { flex: 1, overflow: "auto", padding: 0 }, children: _jsx("div", { style: { height: "100%", overflow: "auto" }, children: useCategoryGroups ? (
            // 使用一级分类（可折叠）方式
            _jsx(Collapse, { activeKey: expandedKeys, onChange: (keys) => setExpandedKeys(keys), ghost: true, expandIcon: ({ isActive }) => (_jsx(DownOutlined, { rotate: isActive ? 180 : 0, style: { fontSize: "12px" } })), style: { backgroundColor: "transparent" }, children: categoryGroups.map((categoryGroup, index) => renderCategoryGroup(categoryGroup, index)) })) : useGroups ? (
            // 使用原来的方式（向后兼容）
            groups.map((group, index) => renderGroup(group, index))) : null }) }));
};
export default CompsApiList;
